import { render, staticRenderFns } from "./DialogEditModels.vue?vue&type=template&id=2bad217c&scoped=true"
import script from "./DialogEditModels.js?vue&type=script&lang=js&external"
export * from "./DialogEditModels.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad217c",
  null
  
)

export default component.exports